<script setup>
import { ref } from 'vue';

import AuditTrails from './AuditTrails.vue';

defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  filters: { type: Array, default: () => [] },
});

const isOpen = ref(false);
const toggle = () => {
  isOpen.value = !isOpen.value;
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <button
      type="button"
      class="flex items-start justify-between w-full text-left gap-3"
      @click="toggle"
    >
      <div class="flex flex-col gap-2">
        <h3 class="text-base font-medium leading-6 text-n-slate-12">
          <span class="truncate">{{ title }}</span>
        </h3>
        <p v-if="description" class="mb-0 text-sm text-n-slate-11">
          {{ description }}
        </p>
      </div>
      <span
        class="i-lucide-chevron-down size-5 shrink-0 mt-1 text-n-slate-11 transition-transform duration-200"
        :class="{ 'rotate-180': isOpen }"
      />
    </button>

    <div v-if="isOpen" class="mt-2">
      <AuditTrails :filters="filters" />
    </div>
  </div>
</template>
